const init = () => {
    if(typeof window.spinner === 'undefined') {
        window.spinner = {
            shown: false,
            show: (item) => {
                window.spinner.hide();

                let rootEl = item;
                if(typeof rootEl === 'undefined' || rootEl.length < 1) {
                    rootEl = $('[data-pl-spinner=container]');
                }
                if(rootEl.length > 0) {
                    const spinnerEl = $('<div class="spinner-container">' +
                        '<div class="spinner-backdrop"></div>' +
                        '<div class="spinner-item"><i class="fa-thin fa-circle-notch fa-spin"></i></div>' +
                        '</div>');
                    rootEl.append(spinnerEl);
                    const rootElHeight = rootEl.height();
                    const windowHeight = $(window).height();
                    if(rootElHeight <= windowHeight) {
                        if(rootElHeight < 1) {
                            const inEl = spinnerEl.find('.spinner-item');
                            inEl.css({
                                'position': 'absolute !important',
                                'top': Math.floor((spinnerEl.height() - (inEl.height() / 2)) / 2) + 'px'
                            });
                        }
                    }
                    window.spinner.shown = true;
                }
            },
            hide: () => {
                if(window.spinner.shown) {
                    $('.spinner-container').remove();
                    window.spinner.shown = false;
                }
            },
            showSubmitStatus: (rootEl, changeLabel) => {
                let statusEl = null;
                if(typeof rootEl !== 'undefined') {
                    statusEl = rootEl.find('[data-pl-spinner]');
                    if(statusEl.length < 1) {
                        statusEl = rootEl;
                    }
                    if(typeof changeLabel === 'undefined') {
                        changeLabel = false;
                    }
                    if(statusEl.length > 0) {
                        statusEl.prop('disabled', true);
                        if(changeLabel) {
                            const baseHtml = statusEl.html();
                            statusEl.html('<span class="spinner-status me-3"><i class="fa-thin fa-circle-notch fa-spin"></i></span>' + baseHtml);
                        }
                        statusEl.attr('data-pl-spinner','');
                    }
                }
            },
            hideSubmitStatus: () => {
                $('[data-pl-spinner]').each(function() {
                    const submitEl = $( this );
                    submitEl.find('.spinner-status').remove();
                    submitEl.prop('disabled', false);
                });

            }
        };
    }
};

export {
    init,
}
